import { Search } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { colors } from '@themes/colors';
import { ChangeEvent, ChangeEventHandler, useEffect, useState } from 'react';

export type SearchInputProps = Pick<TextFieldProps, 'onKeyDown' | 'onFocus' | 'sx'> & {
  placeholder?: string;
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const SearchInput = ({ value, placeholder, onChange, ...props }: SearchInputProps) => {
  const [currentValue, setCurrentValue] = useState(value);
  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange && typeof onChange === 'function') {
      onChange(event);
    }
    setCurrentValue(event.target.value);
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <>
      <TextField
        variant='outlined'
        value={currentValue}
        placeholder={placeholder}
        onChange={changeHandler}
        size='small'
        autoComplete='none'
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search />
            </InputAdornment>
          ),
          sx: {
            borderRadius: '4px',
            background: colors.background.main,
            '.MuiOutlinedInput-notchedOutline': { border: '0 !important ' },
          },
        }}
        {...props}
      />
    </>
  );
};
